import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import './breakdown-table.scss';

import { useTableData } from './BreakdownTable.helpers';
import { TableHeader, TableHeaderGroup } from '../TableComponents';
import { ICurrencyFormat } from '../../../utils/types';
import { TableWrapper } from '../Table.styles';

export const BreakdownTable = ({
  columnDateLabels,
  columnTitles,
  format,
  rowData,
}: {
  columnDateLabels: string[];
  columnTitles: string[];
  format: ICurrencyFormat;
  rowData: Array<{
    [x: string]: string | number | undefined | null;
  }>;
}) => {
  const columnDefs = useTableData(columnTitles, columnDateLabels, format);
  return (
    <TableWrapper className="ag-theme-balham">
      <AgGridReact
        columnDefs={columnDefs}
        frameworkComponents={{
          customHeaderGroupComponent: TableHeaderGroup,
          agColumnHeader: TableHeader,
        }}
        defaultColDef={{
          width: 75,
          suppressMenu: true,
        }}
        rowHeight={24}
        rowData={rowData}
        suppressCopyRowsToClipboard
        suppressScrollOnNewData
        suppressRowHoverHighlight
        suppressRowDrag
        suppressRowClickSelection
        suppressCellSelection
        suppressCsvExport
        suppressExcelExport
        suppressContextMenu
        domLayout="autoHeight"
      />
    </TableWrapper>
  );
};

export default BreakdownTable;
